import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Calendar } from "lucide-react";

export default function FloatingBookButton() {
  const [show, setShow] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handler = () => setShow(window.scrollY > 400);
    handler();
    window.addEventListener("scroll", handler, { passive: true });
    return () => window.removeEventListener("scroll", handler);
  }, []);

  if (location.pathname.startsWith("/book")) return null;
  if (!show) return null;

  return (
    <Link
      to="/book"
      data-testid="floating-book-now-btn"
      className="fixed z-40 bottom-5 right-5 sm:bottom-7 sm:right-7 btn-pickle floating-pulse rounded-full pl-5 pr-6 py-3.5 inline-flex items-center gap-2.5 text-sm shadow-2xl animate-in fade-in slide-in-from-bottom-4 duration-500"
      aria-label="Book now"
    >
      <Calendar size={18} strokeWidth={2.5} />
      <span className="font-bold tracking-wide">Book Now</span>
    </Link>
  );
}
